export class TypeGuards {
    /**
     * A naive type guard to check if we are dealing with a string array.
     *
     * @remarks
     * Only checks if the first element of the array is of type "string".
     *
     * @param obj - An array
     */
    static isStringArray(obj: Array<unknown>): obj is Array<string> {
        return obj != null && obj.length > 0 && typeof obj[0] === "string";
    }

    /**
     * A naive type guard to check if we are dealing with a number array.
     *
     * @remarks
     * Only checks if the first element of the array is of type "number".
     *
     * @param obj - An array
     */
    static isNumberArray(obj: Array<unknown>): obj is Array<number> {
        return obj != null && obj.length > 0 && typeof obj[0] === "number";
    }
}
